module.exports = "<app-channel-list-page></app-channel-list-page>"